import { FC, memo, useMemo, useRef, useState } from 'react'
import type { Analytic, Pages } from '@app/types'
import {
  dataListStyle,
  pagingListStyle,
} from '@app/components/general/cells/card/head-style'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { PagingSearch } from '../../lists/render/issues/paging-search'
import { PagesList } from '../../lists/render/issues/pages-list'
import { InnerWrapper } from '../../lists/list-wrapper'
import { useSearchQuery } from '@app/data/local/useSearchQuery'
import { classNames } from '@app/utils'

type AnalyticPage = Analytic & {
  __typename?: any
  pageLoadTime?: { duration?: number }
}

type PagesPagingProps = {
  pageUrl?: string
  liveData?: AnalyticPage[]
  open?: boolean
  handleMainClick?(): any // modal
  extraActive?: boolean
}

// paging issues for website dashboard cell
const RenderInnerPagesWrapperMock: FC<PagesPagingProps> = ({
  liveData,
  //   pageUrl,
  open: defaultOpen,
  handleMainClick,
  extraActive,
}) => {
  const [issueIndex, setIndex] = useState<number>(0)
  const searchRef = useRef<HTMLInputElement | null>(null)
  const { search, visible, onSearchEvent } = useSearchQuery()
  const { t } = useTranslation('dashboard')

  const { issueSource } = useMemo(() => {
    const liveDataExist = liveData?.length

    const dataSource = search
      ? liveData?.filter((data) => data.pageUrl.includes(search))
      : liveData

    return {
      issueSource: dataSource || [],
      liveDataExist,
    }
  }, [liveData, search])

  // todo: memo hooks
  const [issueList, stats] = useMemo(() => {
    const items: Pages[] = []
    let totalTTL = 0

    if (issueSource) {
      const base = (issueIndex + 1) * 10

      for (let i = base - 10; i < base; i++) {
        const item = issueSource[i]
        if (!item) {
          break
        }

        if (
          item.pageLoadTime &&
          typeof item.pageLoadTime.duration === 'number'
        ) {
          totalTTL += item.pageLoadTime.duration
        }

        items.push(item)
      }
    }

    return [items, { totalTTL }]
  }, [issueIndex, issueSource])

  const onPrevSelect = () => {
    if (issueIndex) {
      setIndex((x: number) => x - 1)
    }
  }

  const idx = (issueIndex + 1) * 10
  const blocked = issueSource.length < idx

  const onLoadEvent = async () => {
    // get the next set of data
    if (idx === issueSource.length) {
    }
    setIndex((x: number) => x + 1)
  }

  const onSearchSubmit = async (e: React.FormEvent) => {
    e?.preventDefault()
    if (!search) {
      setIndex(0)
    } else {
    }
  }

  return (
    <>
      <div className='flex flex-col place-content-around'>
        <div className={dataListStyle}>
          <InnerWrapper data={issueSource.length} loading={false}>
            <ul className={classNames(pagingListStyle, 'pr-4')}>
              {issueList.map((page) => (
                <PagesList
                  key={page?._id ?? page.url ?? page.pageUrl}
                  open={defaultOpen}
                  pageLoadTime={page.pageLoadTime}
                  online={page.online}
                  domain={page.domain}
                  url={page.url ?? page.pageUrl}
                  totalTTL={stats.totalTTL}
                  extraActive={extraActive}
                  demo
                  t={t}
                  handleMainClick={handleMainClick}
                />
              ))}
            </ul>
          </InnerWrapper>
        </div>

        <PagingSearch
          searchVisible={visible}
          onLoadEvent={onLoadEvent}
          onPrevSelect={onPrevSelect}
          onSearchEvent={onSearchEvent}
          onSearchSubmit={onSearchSubmit}
          loading={false}
          blocked={blocked}
          ref={searchRef}
          issueIndex={issueIndex}
          source={issueSource}
          pages
          t={t}
        />
      </div>
    </>
  )
}

export const RenderInnerPagesPagingMock = memo(RenderInnerPagesWrapperMock)
